import MapObjMarkers from './MapObjMarkers'

export default MapObjMarkers;
